import { createIcon } from "@chakra-ui/react";

export const BookClosed = createIcon({
  displayName: "BookClosed",
  viewBox: "0 0 32 32",
  d: "M1.333 5.5a5.5 5.5 0 0 1 5.5-5.5h19c1.932 0 3.5 1.569 3.5 3.5v18c0 1.394-.818 2.6-2 3.163V29h.5c.832 0 1.5.669 1.5 1.5s-.668 1.5-1.5 1.5h-21.5a4.999 4.999 0 0 1-4.974-5.5h-.026v-21zm5 19.5c-1.106 0-2 .894-2 2 0 1.106.894 2 2 2h18v-4h-18zm-2-2.581a4.96 4.96 0 0 1 2-.419h19.5c.276 0 .5-.225.5-.5v-18c0-.275-.224-.5-.5-.5h-19a2.5 2.5 0 0 0-2.5 2.5v16.919zM10.834 7h11c.832 0 1.5.669 1.5 1.5s-.668 1.5-1.5 1.5h-11c-.83 0-1.5-.669-1.5-1.5s.67-1.5 1.5-1.5zm0 5h11c.832 0 1.5.669 1.5 1.5s-.668 1.5-1.5 1.5h-11c-.83 0-1.5-.669-1.5-1.5s.67-1.5 1.5-1.5z",
  defaultProps: {
    "aria-label": "A symbolic sheet of paper with lines within"
  }
});

export default BookClosed;
